import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()

export const actions = {
  setMeta: action({
    type: 'layout.setmeta',
    action(meta) {
      return meta
    },
    handler(state, meta) {
      return { meta }
    }
  }, reducerHandler),

}

export const reducer = reducerHandler({ meta: {} })



// WEBPACK FOOTER //
// ./components/layout/redux.js